// maintain alphabetical order
export const jaCommon = {
  ABFilters: 'A/Bフィルター',
  ABFiltersWithAsterisk: 'A/Bフィルター *',
  ABTest: 'A/Bテスト',
  ABTestingTraffic: 'A/Bテストトラフィック',
  Accept: '受け入れる',
  Account: 'アカウント',
  Action: 'アクション',
  Actions: 'アクション',
  Active: '有効',
  ActiveColumn: 'アクティブな列',
  ActiveColumns: 'アクティブな列',
  ActiveFields: 'アクティブフィールド',
  AdaptiveFloors: 'アダプティブフロア',
  AdBreakDetails: '広告休憩の詳細',
  AdBreakID: '広告ブレークID',
  AdBreakTooltipBreakdown: '各広告ブレークの情報の内訳',
  AdBreakWithAsterisk: 'Ad Break *',
  AdCode: '広告コード',
  AddEditItem: '{{item}} を追加/編集',
  AddFilter: 'フィルターを追加',
  AddItem: '{{item}} を追加',
  AddMetric: 'メトリックを追加',
  AddNewExtensionKeyValueParameter: '新しい拡張キーバリューパラメータを追加する',
  AddNewKeyValueParameter: '新しいキーバリューパラメータを追加する',
  AddToGroup: 'グループに追加',
  AddValueOnlyIfObjEmptyInBidRequest: 'ビッドリクエスト内のオブジェクトが空の場合のみ、値を追加する',
  AdInsertion: 'SSAI',
  Adomain: 'アドメイン',
  Adomains: 'Adomain',
  AdUnit: '広告ユニット',
  Advertiser: '広告主',
  Advertisers: '広告主',
  Africa: 'アフリカ',
  All: '全て',
  AllDirect: 'ダイレクト全て',
  AllHouse: 'ハウス全て',
  AllItems: 'すべて {{item}}',
  AllItemsSelected: '{{item}} すべて選択済み',
  AllLineItems: '全てのラインアイテム',
  Allow: '許可する',
  AllowAll: 'すべて許可',
  Allowed: '許可',
  AllowedItem: '許可された {{item}}',
  AllUsers: 'すべてのユーザー',
  AMPM: '午前/午後',
  And: 'And',
  AnonymizeDeviceID: 'デバイスIDを匿名化する',
  AnonymizeIP: 'IPを匿名化する',
  AnyPod: 'どのポッドでも',
  APAC: 'アジア太平洋地域',
  App: 'アプリ',
  AppAndSite: 'アプリとサイト',
  AppBundle: 'アプリバンドル',
  AppBundleID: 'アプリバンドルID',
  AppBundleIDAllowed: 'アプリバンドルIDが許可されました',
  AppBundleIDDescriptionWithExample: '入札するアプリバンドル ID（例: {{text}}）',
  AppBundleIDs: 'アプリバンドルID',
  AppBundleIDsAndSitePages: 'アップバンドル IDとサイトページ',
  AppBundleOverride: 'アプリバンドルのオーバーライド',
  AppBundleOverrideIfEmpty: 'アプリバンドルが空の場合にオーバーライド',
  AppDomain: 'アプリドメイン',
  AppDomainOverride: 'アプリドメインのオーバーライド',
  AppDomainOverrideIfEmpty: 'アプリドメインが空の場合にオーバーライド',
  AppDomainOverrideWithAsterisk: 'アプリドメインのオーバーライド *',
  AppID: 'App ID',
  AppIDOverride: 'App ID上書き',
  AppIDOverrideIfEmpty: '空の場合のアプリIDの上書き',
  AppIDWebExchangeIDOTT: 'app_id (ウェブ) exchange_id (OTT)',
  Apply: '適用する',
  AppName: 'アプリ名',
  AppNameOverride: 'アプリ名のオーバーライド',
  AppNameOverrideIfEmpty: 'アプリ名が空の場合にオーバーライド',
  AppSite: 'アプリサイト',
  AppStoreURL: 'App StoreのURL',
  AppStoreURLWithAsterisk: 'App StoreのURL *',
  AppWithAsterisk: 'アプリ *',
  Ascending: '昇順',
  At: 'で',
  AuctionParticipationPercentage: 'オークション参加率',
  AuctionType: 'オークションの種類',
  Audience: 'オーディエンス',
  AudienceSegments: 'オーディエンスセグメント',
  AutoRefresh: '自動更新',
  AvgCPML24H: '平均CPM（24時間後）',
  AvgCPML7D: '平均CPM（L7D）',
  AWSS3: 'AWS S3',
  BackToItemList: '< {{item}} リストに戻る',
  BaseFloor: 'ベースフロア',
  Beta: 'ベータ',
  BidAdjustment: 'ビッド調整',
  BidAdjValue: 'ビッド調整値',
  Bidder: 'ビダー',
  BidderGroup: 'ビダーグループ',
  BidderGroupLabels: 'ビダーグループラベル',
  BidderGroups: 'ビダーグループ',
  BidderID: 'ビダーID',
  BidderIDs: 'ビダーID',
  BidderLabel: 'ビダーラベル',
  BidderLabels: 'ビダーラベル',
  BidderLevelExtendedID: 'ビダーレベルの拡張ID',
  Bidders: 'ビダー',
  BidderSettings: 'ビダー設定',
  BidderSubTier: 'ビダーサブティア',
  BidderTier: 'ビダーティア',
  BidderTiers: 'ビダーティア',
  BidderTimeout: 'ビダーのタイムアウト',
  BidderType: 'ビダータイプ',
  BidderTypes: 'ビダータイプ',
  BidErrors: 'ビッドエラー',
  BidFloor: '入札最低価格',
  BidFloorAdjustment: 'フロア調節',
  BidFloorCurrency: '入札最低通貨',
  BidRequest: 'ビッドリクエスト',
  BidRequestRewrite: 'ビッドリクエストの書き換え',
  BidRequests: 'ビッドリクエスト',
  BidResponses: 'ビッドレスポンス',
  Block: 'ブロック',
  Blocked: 'ブロックされました',
  BrandSafety: 'ブランドセーフティー',
  BrandSafetyRule: 'ブランドセーフティールール',
  BrandSafetyRules: 'ブランドセーフティールール',
  BrandsDashboard: 'ブランドダッシュボード',
  BulkUpdate: '一括更新',
  BulkUpload: '一括アップロード',
  BulkUploaderWiki: '一括アップローダー Wiki',
  BuyingPartner: 'バイヤーパートナー',
  BuyType: '購入タイプ',
  ByPod: 'ポッドで',
  ByPodDuration: 'ポッド期間別',
  Campaigns: 'キャンペーン',
  CampaignStatus: 'キャンペーンのステータス',
  CampaignStatusTooltipCompleted: 'キャンペーンは終了しました。',
  CampaignStatusTooltipDelivering: 'キャンペーン配信中です。',
  CampaignStatusTooltipDraft: 'キャンペーンにクリエイティブがありません。',
  CampaignStatusTooltipGoalMet: '配信目標は達成されました。キャンペーンは配信されなくなりました。',
  CampaignStatusTooltipInactive: 'キャンペーン タグが非アクティブです。',
  CampaignStatusTooltipMediafileError: 'アップロードされたメディアファイルは破損しているか、バナーの要件を満たしていません。キャンペーン配信を有効にするには、ファイルを修正してください。',
  CampaignStatusTooltipNotStartedYet: 'キャンペーンの開始日は将来の日付です。',
  CampaignStatusTooltipReady: 'キャンペーンは開始されましたが、ファーストインプレッションはまだ保留中です。ファーストインプレッションが記録され次第、キャンペーンのステータスが「配信中」に更新されます。',
  CampaignStatusTooltipUntargeted: 'キャンペーンはどのビダーにもターゲット設定されていません。ビダーページに移動して設定を完了してください。',
  CanBeCommaSeparated: 'カンマ区切りで入力できます',
  Cancel: 'キャンセル',
  Category: 'カテゴリ',
  CCPA: 'CCPA',
  ChangeLogs: 'チェンジログ',
  Channel: 'チャネル',
  ChannelFloors: 'チャネルフロア',
  ChannelGroup: 'チャンネルグループ',
  ChannelGroups: 'チャンネルグループ',
  ChannelLabel: 'チャンネルラベル',
  ChannelLabels: 'チャンネルラベル',
  ChannelList: 'チャンネルリスト',
  ChannelLists: 'チャンネルリスト',
  Channels: 'チャンネル',
  Chart: 'チャート',
  ChartDisplay: 'チャート表示',
  Cities: '都市',
  City: '市',
  Clear: 'クリア',
  ClearAll: 'すべてクリア',
  ClearBitrate: 'クリアビットレート',
  ClearDates: '日付をクリア',
  ClearDefaultMaxMinBitrate: 'デフォルトの最大/最小ビットレートをクリアします。',
  ClearItem: '{{item}}をクリア',
  ClearMaxMinBitrate: '最大/最小ビットレートをクリアします。',
  ClickSoundOn: 'クリックで音声オン',
  Clone: '複製',
  Cloned: 'クローン',
  CloneItem: '{{item}} の複製',
  Close: 'クローズ',
  CollapseAll: '全て最小表示にする',
  CombineVMAPRequests: 'VMAPリクエストを組み合わせる',
  CombineVMAPRequestsWithAsterisk: 'VMAPリクエストを組み合わせる*',
  CommaSeparated: 'カンマ区切り',
  CommonCountryGroups: '共通国グループ',
  Company: '会社',
  Compare: '比較',
  ComparedTo: 'に比べ',
  Completed: '完了',
  Configurations: '設定',
  Confirm: '確認する',
  ConfirmBulkEditItem: '{{items}} の一括編集を確認',
  ConfirmSaveItem: '{{item}} の保存を確認',
  Contains: '含まれるもの',
  Content: 'コンテンツ',
  ContentCategory: 'コンテンツカテゴリ',
  ContentChannel: 'コンテンツチャンネル',
  ContentContext: 'コンテンツのコンテキスト',
  ContentDistributionID: 'コンテンツ配信ID',
  ContentDistributionName: 'コンテンツ配信名',
  ContentDistributor: 'コンテンツ配信者',
  ContentDistributorName: 'コンテンツ配信者名',
  ContentDistributorNameOverride: 'コンテンツ配信者名のオーバーライド',
  ContentDistributorNameOverrideIfEmpty: 'コンテンツ配信者名が空の場合に上書き',
  ContentEpisode: 'コンテンツエピソード',
  ContentGenre: 'コンテンツジャンル',
  ContentID: 'コンテンツID',
  ContentItem: 'コンテンツ {{item}}',
  ContentItemAllowed: '許可されているコンテンツ {{item}}',
  ContentItemOverride: 'コンテンツアイテムの上書き',
  ContentKeywords: 'コンテンツキーワード',
  ContentLanguage: 'コンテンツ言語',
  ContentLength: 'コンテンツの長さ',
  ContentNetwork: 'コンテンツネットワーク',
  ContentProdQuality: 'コンテンツ製品の品質',
  ContentProducer: 'コンテンツプロデューサー',
  ContentProducerID: 'コンテンツプロデューサーID',
  ContentRating: 'コンテンツ評価',
  ContentSeason: 'コンテンツシーズン',
  ContentSeries: 'コンテンツシリーズ',
  ContentTaxonomy: 'コンテンツ分類',
  ContentTitle: 'コンテントタイトル',
  ContentURL: 'コンテンツURL',
  ContentWithAsterisk: 'コンテンツ *',
  Contextual: 'コンテキスト',
  ContextualSegment: 'コンテキストセグメント',
  ContextualSegmentIDs: 'コンテキストセグメントID',
  ContextualSegments: 'コンテキストセグメント',
  COPPA: 'COPPA',
  Copy: 'コピー',
  Countries: '国',
  CountriesTargeted: '対象国',
  Country: '国',
  CountryGroup: '国グループ',
  CountryGroups: '国グループ',
  CPMOrCPMS: 'CPM または CPM/S',
  CreateBidder: 'ビダー作成',
  CreateBidderGroup: 'ビダーグループを作成する',
  CreatedBy: '作成者',
  CreatedDate: '作成日',
  CreateItem: '{{item}} を作成する',
  CreateNewItem: '新しい {{item}} を作成する',
  CreatingNewGroup: '新しいグループの作成',
  Creative: 'クリエイティブ',
  CreativeID: 'クリエイティブID',
  CreativeLibrary: 'クリエイティブライブラリ',
  CreativeReview: 'クリエイティブレビュー',
  CreativeReviews: 'クリエイティブレビュー',
  Creatives: 'クリエイティブ',
  CreativeURL: 'クリエイティブURL',
  CreativeURLs: 'クリエイティブURL',
  CreativeValidation: 'クリエイティブ検証',
  CreativeValidations: 'クリエイティブ検証',
  CSVLastUpdated: 'CSV最終更新',
  CSVSummary: 'CSV概要',
  CuePointTypes: 'キューポイントの種類',
  CuePointValue: 'キューポイント値',
  Currency: '通貨',
  CurrencyExchangeRate: '為替レート',
  CurrentEditsWillImpactTheFollowing: '現在の編集は以下に適応されます',
  CurrentMonth: '今月',
  CurrentTest: '現在のテスト',
  CurrentUser: '現在のユーザー',
  CurrentYear: '今年',
  Custom: 'カスタム',
  Custom10: 'カスタム10',
  Custom11: 'カスタム11',
  Custom12: 'カスタム12',
  Custom13: 'カスタム13',
  Custom14: 'カスタム14',
  Custom15: 'カスタム15',
  Custom16: 'カスタム16',
  Custom17: 'カスタム17',
  Custom18: 'カスタム18',
  Custom4: 'カスタム4',
  Custom5: 'カスタム5',
  Custom6: 'カスタム6',
  Custom7: 'カスタム7',
  Custom8: 'カスタム8',
  Custom9: 'カスタム9',
  CustomItemInclusion: 'カスタム {{item}} を含む',
  CustomItemName: 'カスタム {{item}} 名',
  CustomizeData: 'データのカスタマイズ',
  CustomMetric: 'カスタムメトリック',
  CustomTargeting: 'カスタムターゲティング',
  Daily: '毎日',
  DailyRequestCap: '1日あたりのリクエスト上限',
  Dashboard: 'ダッシュボード',
  Dashboards: 'ダッシュボード',
  Data: 'データ',
  DataSharing: 'データ共有',
  DateRange: '日付範囲',
  Dayparting: 'デイパーティング',
  DaypartingActive: 'デイパーティングアクティブ',
  DaypartingExcludeDescription: '{{item}} は選択された時間と曜日には配信されません。',
  DaypartingIncludeDescription: '{{item}}は選択した時間と曜日に配信します',
  DaypartingIncludeExclude: 'デイパーティングの含める／除外する',
  DaypartingIsAllowed: 'デイパーティングが許可されている',
  Daypartings: 'デイパーティング',
  DaypartingTimezoneBidder: 'ビッダーのタイムゾーン',
  DaypartingTimezoneBidderDescription: 'デイパーティングは、視聴者のデバイスの位置情報を使用して、その視聴者のタイムゾーンに基づいて適用されます。',
  DaypartingTimezoneBrandSafetyRule: 'ルールのタイムゾーン',
  DaypartingTimezoneBrandSafetyRuleDescription: 'デイパーティングは、ブランドセーフティルールに設定されたタイムゾーンに従って適用されます。',
  DaypartingTimezoneDeviceLocation: '視聴者のタイムゾーン',
  DaypartingTimezoneDeviceLocationDescription: 'デイパーティングは、視聴者のデバイスの位置情報を基に、その視聴者のタイムゾーンに従って適用されます。',
  DaypartingTimezoneLineItem: 'ラインアイテムのタイムゾーン',
  DaypartingTimezonePublisher: 'パブリッシャーのタイムゾーン',
  DaypartingTimezonePublisherDescription: 'デイパーティングはパブリッシャーに設定されたタイムゾーンに準拠します。',
  DaypartingTooltip: 'デイパーティングを使用して、この{{item}}を実行する曜日と時間を設定します。複数のオプションを追加すると、よりきめ細かな設定が可能になります。',
  DealID: 'Deal ID',
  DealIDPassthrough: 'ディールIDパススルー',
  DealIDPassthroughFromEndpoint: 'エンドポイントからの Deal ID パススルー',
  DealIDs: 'ディールID',
  DealPriorityOverride: 'ディールの優先順位のオーバーライド',
  Deals: 'ディール',
  DebugPrebidDataWithAsterisk: 'デバッグ（入札前データ）*',
  Default: 'デフォルト',
  Delete: '削除',
  DeliveredImpressions: '配信されたインプレッション',
  DeliveredToDate: '現在までのデリバリー',
  Delivering: 'デリバリー',
  Delivery: 'デリバリー',
  DeliveryGoalMet: 'デリバリー目標達成',
  Demand: 'デマンド',
  DemandSource: 'デマンドソース',
  DemandSources: 'デマンドソース',
  DemandSourceSettings: 'デマンドソース設定',
  Denied: '拒否',
  Descending: '降順',
  Description: '説明',
  Destinations: 'デスティネーション',
  Device: 'デバイス',
  DeviceEnvironment: 'デバイス環境',
  DeviceEnvironments: 'デバイス環境',
  Devices: 'デバイス',
  DeviceTypes: 'デバイスの種類',
  Dimension: 'ディメンション',
  Dimensions: 'ディメンション',
  Disable: '無効にする',
  Disabled: '無効',
  DisabledWhileInTesting: 'テスト中は無効になります。',
  DisableSamplingWithAsterisk: 'サンプリングを無効にする*',
  Distributor: 'ディストリビューター',
  DistributorName: '配信元名',
  DMA: 'DMA',
  DMACode: 'DMAコード',
  DMAs: 'DMA',
  DontPassID: 'IDを渡さない',
  DOOHBidder: 'DOOHビダー',
  DOOHDeviceTypeRewrite: 'DOOHデバイスタイプの書き換え',
  Download: 'ダウンロード',
  DownloadComplete: 'ダウンロード完了',
  DownloadFailed: 'ダウンロードに失敗しました',
  Draft: 'ドラフト',
  Drill: '詳細',
  Duration: '間隔',
  Dynamic: 'ダイナミック',
  EditingGroup: 'グループ編集',
  EditItem: '{{item}} を編集',
  EleaAIEnrichment: 'Elea AIエンリッチメント',
  Email: 'メール',
  EmailAddress: 'メールアドレス',
  EmailAddresses: 'メールアドレス',
  EMEA: 'EMEA',
  EmptyString: '空の文字列',
  Enable: '有効にする',
  Enabled: '有効',
  EnableItem: '{{item}} を有効にする',
  End: '終わり',
  EndDate: '終了日',
  EndDateRange: '終了日範囲',
  Endpoint: 'エンドポイント',
  EndpointDealID: 'エンドポイント ディールID',
  EndpointDomain: 'エンドポイントドメイン',
  EndpointIDKey: 'エンドポイントID（キー）',
  EndpointPrefix: 'エンドポイントプレフィックス',
  EndpointReqL24H: 'エンドポイント (L24H)',
  EndpointReqL7D: 'エンドポイント (L7D)',
  EndpointRequest: 'エンドポイントリクエスト',
  EndpointRequests: 'エンドポイントリクエスト',
  EndpointRoute: 'エンドポイントルート',
  EndpointSubdomain: 'エンドポイントサブドメイン',
  EndTime: '終了時間',
  EnforceMatchingDealIDInBidResponse: 'ビッドレスポンスでディールIDが一致する場合のみ入札を使用する',
  EnforceSlotTargeting: 'スロットターゲティングを強制適用する',
  English: '英語',
  EnteringViewportSoundOff: 'ビューポートに入っても音声オフ',
  EnteringViewportSoundOn: 'ビューポートに入ると音声オン',
  EnterItemOrUploadCSV: '{{item}}を入力するか、CSVをアップロードしてください',
  EnterLimit: 'リミットを入力',
  Error: 'エラー',
  ErrorBidAdjustmentCannotBeMoreThan200Percent: '入札調整は 200% を超えることはできません。',
  ErrorBidAdjustmentValueCannotBeNegative: '入札調整値は負の値にはできません。',
  ErrorBidderParamsTotalCannotExceed65535Characters: 'ビダーパラメータの合計は 65,535 文字を超えることはできません。',
  ErrorBidFloorMustBe0OrHigher: '入札最低額は $0 以上である必要があります ($0 の場合は空白のままにしてください)。',
  ErrorCannotIncludeAndExcludeTheSameLocalTargetForItemWithReasons: '{{item}}: {{text}} に対して同じローカル ターゲットを追加および除外することはできません。',
  ErrorCannotUseVarABecauseNotSelectedInMetricADropdown: 'メトリック A ドロップダウンで選択されていないため、変数「a」を使用できません。',
  ErrorCannotUseVarBBecauseNotSelectedInMetricBDropdown: 'メトリック B ドロップダウンで選択されていないため、変数「b」を使用できません。',
  ErrorChooseCustomName: 'カスタム名を選択します。',
  ErrorDailyRequestCapMustBeGreaterOrEqual10k: '1 日のリクエスト上限は 10,000 以上である必要があります。',
  ErrorDailyRequestCapMustBeValidPositiveInteger: '1 日あたりのリクエスト上限は有効な正の整数である必要があります。',
  ErrorDuplicateEventTrackersInCSVFileWithReasons: 'CSV ファイル内のメディアファイルのイベント トラッカーが重複しています: {{text}}。',
  ErrorDuplicateMediafilesInCSVFileWithReasons: 'CSV ファイル内のメディアファイルのドメイン名が重複しています: {{text}}。',
  ErrorDuplicateValueForLocalPanelForItemWithReasons: 'ローカル パネル {{item}} の値が重複しています: {{text}}。',
  ErrorEmptyItem: '空の {{item}}',
  ErrorEndDateMustBeAfterStartDate: '終了日は開始日より後にする必要があります。',
  ErrorEndTimeMustBeAfterStartTime: '終了時間は開始時間より後である必要があります。',
  ErrorFailedToAddItemToIABCatBlocklist: '{{item}} を IABCatBlocklist に追加できませんでした。すでに追加されています。',
  ErrorGenericSystemFailure: 'エラーが発生しました。もう一度お試しください。問題が解決しない場合は、アカウントマネージャーにご連絡ください。速やかに調査いたします。',
  ErrorIndexMustBe1: 'インデックスは 1 でなければなりません。',
  ErrorInvalidEventTrackersInCSVFileWithReasons: 'CSV ファイル内のメディアファイルのイベント トラッカーが無効です: {{text}}。',
  ErrorInvalidItem: '無効な {{item}}',
  ErrorInvalidItemWithReasons: '無効な {{item}}: {{text}}',
  ErrorInvalidMediafilesInCSVFileWithReasons: 'CSV ファイル内のメディアファイルのドメイン名が無効です: {{text}}。',
  ErrorInvalidNotification: '通知が無効です。',
  ErrorInvalidSlackWebhook: 'SlackのWebhookドメインが無効です。https://hooks.slack.comを使用してください。',
  ErrorItemCannotBeEmpty: '{{item}} は空にできません。',
  ErrorItemIsRequired: '{{item}} は必須です。',
  ErrorItemMustBeBetweenNumAndAltNum: '{{item}} は {{number}} から {{altNumber}} までの範囲にする必要があります。',
  ErrorItemMustBeValidNumber: '{{item}} は有効な数値である必要があります。',
  ErrorItemMustHaveValueGreaterThanOrEqualToNum: '{{item}} の値は {{number}} 以上である必要があります。',
  ErrorItemNameCannotIncludeCommas: '{{item}} の名前にはコンマを含めることはできません。',
  ErrorItemNameCannotIncludeQuotes: '{{item}} の名前には引用符を含めることはできません。',
  ErrorItemNameCannotIncludeSlashes: '{{item}} の名前にスラッシュを含めることはできません。',
  ErrorItemNameMustBeLessThanNumberCharacters: '{{item}} の名前は {{number}} 文字未満にする必要があります。',
  ErrorKeyMustStartWithAPS: 'キーは「aps」で始まる必要があります。',
  ErrorLoadingData: 'データの読み込みエラー',
  ErrorLoadingItem: '{{item}} の読み込み中にエラーが発生しました',
  ErrorMalformedInputDetectedInFields: 'フィールドで不正な入力が検出されました: {{item}}。',
  ErrorMaximumDecimalsForShareOfVoiceIs4: 'シェア・オブ・ボイスの最大小数点は 4 です。',
  ErrorNoRecipientsSelected: '受信者が選択されていません。',
  ErrorOnlyCSVFilesAreSupported: 'CSV ファイルのみがサポートされます。',
  ErrorPleaseChoosePriceRange: '価格帯を選択してください。',
  ErrorPleaseEnterAFixedPrice: '固定価格を入力してください。',
  ErrorPleaseEnterAFixedPriceGreaterThan0: '0より大きい固定価格を入力してください。',
  ErrorPleaseEnterCustomMetricFormula: 'カスタムメトリックを入力してください。',
  ErrorPleaseEnterValidFormulaBeforeSavingCustomMetric: 'カスタムメトリックを保存する前に、有効な数式を入力してください: {{item}}。',
  ErrorPleaseInputNumberGreaterThanOrEqualToNumber: '{{number}}以上の数字を入力してください。',
  ErrorPleaseInputPositiveNumber: '正の数を入力してください。',
  ErrorPleaseInputUniqueItemName: 'ユニークな {{item}} 名を入力してください。',
  ErrorPleaseInputValidDecimal: '有効な小数を入力してください。',
  ErrorPleaseInputValidIntegerNotDecimal: '小数ではなく有効な整数を入力してください。',
  ErrorPleaseInputValidNumber: '有効な番号を入力してください。',
  ErrorPleaseInputValidPrice: '有効な価格を入力してください。',
  ErrorPleaseInputValidRegionName: '有効な地域名を入力してください。',
  ErrorPleaseOnlyUseOnePeriodForFixedPrice: '固定価格の場合は . を 1 つだけ使用してください。',
  ErrorPleaseProvideINVValue: '「inv」値を指定してください。',
  ErrorPleaseProvideKey: 'キーを入力してください。',
  ErrorPleaseProvideValue: '値を入力してください。',
  ErrorPleaseProvideValueForItem: '{{item}} の値を入力してください。',
  ErrorPleaseResolveAllErrors: '続行する前にすべてのエラーを解決してください。',
  ErrorPleaseSelectMetricAMetricBIsOptional: 'ドロップダウンからメトリック A の値を選択してください (メトリック A は必須、メトリック B はオプションです)。',
  ErrorPleaseUsePeriodAsDecimal: '小数点には、, の代わりに . を使用してください。',
  ErrorPriceMustBeNumber: '価格は数値でなければなりません。',
  ErrorPriceMustBePositiveNumber: '価格は正の数値でなければなりません。',
  ErrorSiteIdDMustBeAnInteger: 'サイト ID は整数である必要があります。',
  ErrorSiteIDMacroIsNotAllowedForOtherVASTTagBidders: '[SITE_ID] マクロは、{{item}} エンドポイントをターゲットとするその他の Vast タグビダーには許可されません。',
  ErrorSmartFloorsAreUpdatingPleaseTrySavingAgain: 'スマートフロアを更新中です。もう一度保存してください。',
  ErrorSorryNoPermissionForSection: '申し訳ありませんが、このセクションに対する権限がありません。',
  ErrorStartDateMustBeBeforeEndDate: '開始日は終了日より前である必要があります。',
  ErrorStartTimeMustBeBeforeEndTime: '開始時刻は終了時刻より前である必要があります。',
  ErrorThisNameIsAKnownDemandSourceType: 'この名前は既知のデマンドソースタイプです。別の名前を入力してください。',
  ErrorValidatingItemPleaseTryAgain: '{{item}} の検証中にエラーが発生しました。もう一度お試しください。',
  ErrorZIPCodeMustBeAtLeastThreeDigits: '郵便番号は3桁以上である必要があります',
  ErrorZIPCodeMustBeNumeric: '郵便番号は数字でなければなりません',
  EventTracker: 'イベントトラッカー',
  EventTrackers: 'イベントトラッカー',
  ExactMatch: '完全一致',
  ExampleTextMatchesAltText: '例: {{text}} は {{altText}} と一致します',
  Exception: '例外',
  Exceptions: '例外',
  ExchangeRate: '為替レート',
  ExchangeTag: 'エクスチェンジタグ',
  Exclude: '除外',
  ExcludeToday: '今日を除外',
  ExpandAll: 'すべて展開',
  ExtendedIDSettingPass: '拡張ID設定パス',
  ExtensionKeyValueParameters: '拡張キーバリューパラメーター',
  FailedToLoadItem: '{{item}} を読み込めませんでした。',
  FallbackAuctionParticipation: 'フォールバックオークション',
  False: 'False',
  Filter: 'フィルター',
  Filters: 'フィルター',
  First: 'ファースト',
  FirstAndLastPod: '最初と最後のポッド',
  FirstOrLast: 'ファーストかラスト',
  FirstPod: '最初のポッド',
  FirstPriceValue1: 'ファーストプライス (value = 1)',
  Fixed: '修正済み',
  FixedPrice: '固定価格',
  FixedPriceValue3: '固定プライス (value = 3)',
  FlexibleBidding: 'フレキシブル入札',
  FlexibleBiddingEnabled: 'フレキシブルビディングが有効',
  FlexibleBiddingThresholds: 'フレキシブルビディングの基準値',
  FlightDates: 'フライト日程',
  FlightEndDate: 'フライト終了日',
  FlightingImpressionGoal: 'フライトインプレッション目標',
  FlightStartDate: 'フライト開始日',
  Floor: 'フロア',
  FloorLimits: 'フロア制限',
  FloorPrice: 'フロア価格',
  FMT: 'FMT',
  Forecast: '予測',
  FormatLabelWithCount: '{{label}} ({{count}})',
  FormatLabelWithSelection: '{{label}}: {{selection}}',
  FormatNumItems: '{{count}} {{item}}',
  FormatSelection: '{{selection}}',
  FormatType: 'フォーマットの種類',
  FreewheelSectionIDs: 'Freewheel Section IDs',
  French: 'フランス語',
  Frequency: '頻度',
  FrequencyCapping: 'フリークエンシーキャップ',
  FrequencyDuration: 'フリークエンシー期間',
  FrequencyImpressionsLimit: 'フリークエンシーインプレッション制限',
  FrequencyUnit: 'フリークエンシー単位',
  From: 'から',
  FWSectionIDs: 'FWセクションID',
  GDPR: 'GDPR',
  GDPRConsent: 'GDPR同意',
  GDPRConsentValue: 'GDPR同意価値',
  General: '一般的な',
  GeneralSettings: '一般設定',
  Genre: 'ジャンル',
  Geo: '地域',
  Geos: '地域',
  German: 'ドイツ語',
  GivnTargeting: 'あらかじめ設定されたターゲティング条件',
  Goal: 'ゴール',
  GooglePair: 'Google Pair',
  GooglePairExtendedIDSetting: 'Google ペア拡張 ID 設定',
  GoToItem: '{{item}}へ移動',
  GroupBy: 'グループ化',
  GroupedBidders: 'ビダーグループ',
  Groups: 'グループ',
  HideInactive: '非アクティブを非表示',
  HideItem: '{{item}}を非表示',
  HighestValueFirst: '最も高い値が最初に表示されます',
  HonorChannelFloor: 'チャンネルフロアを優先',
  Hybrid: 'ハイブリッド',
  IAB: 'IAB',
  IABCat: 'IAB Cat',
  IABCategories: 'IABカテゴリー',
  IABCategory: 'IABカテゴリー',
  IABCode: 'IABコード',
  IABPrefix: 'IABプレフィックス',
  IABSubcategory: 'IABサブカテゴリ',
  IABSuffix: 'IABサフィックス',
  ID: 'ID',
  Immediately: 'すぐに',
  ImpL24H: 'インプレッション (L24H)',
  ImpL7D: 'インプ（L7D）',
  Impression: 'インプレッション',
  ImpressionGoal: 'インプレッション目標',
  Impressions: 'インプレッション',
  ImpressionsPerUserPer: 'ユーザーあたりのインプレッション数',
  ImpTrend: 'インプレッション トレンド',
  Inactive: '無効',
  Include: '含む',
  Increment: '増分',
  InheritFromDemandSource: 'デマンドソースから継承',
  InSeconds: '数秒で。',
  InvalidMediaFile: '無効なメディアファイル',
  Inventory: '在庫',
  InventoryForecast: '在庫予測',
  InventoryPartnerDomain: 'インベントリーパートナードメイン',
  InventoryPartnerDomainOverride: 'インベントリーパートナードメインのオーバーライド',
  InventoryPartnerDomainOverrideIfEmpty: '在庫パートナードメインが空の場合のオーバーライド',
  InventoryPartnerDomainWithAsterisk: 'インベントリーパートナードメイン',
  InventoryRouteTargetingChangeExcludedTooltip: '除外 - 含めるに切り替えます。',
  InventoryRouteTargetingChangeExcludeToIncludeDescription: 'これにより、このフィールドのターゲティングが「除外」から「含める」に変更されます。注: 一度に除外できるデスティネーションパラメータは1つだけです。',
  InventoryRouteTargetingChangeIncludedTooltip: '含まれる - 除外に切り替え - 除外できるデスティネーションパラメータは 1 つだけです。',
  InventoryRouteTargetingChangeIncludeToExcludeDescription: 'これにより、このフィールドのターゲティングが「含める」から「除外」に変更されます。注: 一度に除外できるデスティネーションパラメータは 1 つだけです。',
  InventoryRules: '在庫ルール',
  InventoryType: '在庫タイプ',
  Investigation: '調査',
  IPFilter: 'IPフィルター',
  IPFilters: 'IPフィルター',
  IPFiltersWithAsterisk: 'IPフィルター *',
  IPFilterWithAsterisk: 'IPフィルター *',
  IrisSignal: 'Irisのシグナル',
  Italian: 'イタリア語',
  ItemID: '{{item}} ID',
  ItemIfEmpty: '{{item}} 空の場合',
  ItemIsInvalid: '{{item}} は無効です。',
  ItemManagement: '{{item}} 管理',
  ItemSettings: '{{item}} 設定',
  ItemTargeted: '{{item}} ターゲット',
  ItemToApplyOnCommaSeparated: '適用する{{item}}（カンマ区切り）',
  Japanese: '日本語',
  Key: 'キー',
  KeyLatenciesMS: 'レイテンシー (ms)',
  KeyValueParameters: 'キーバリューパラメーター',
  Keywords: 'キーワード',
  Korean: '韓国語',
  L12HEstimatedUplift: 'L12H 推定上昇率',
  Language: '言語',
  Last: 'ラスト',
  Last12H: '最後の12時間',
  Last14Days: '過去14日間',
  Last15Days: '過去15日間',
  Last30Days: '過去30日間',
  Last31Days: '過去31日間',
  Last3Days: '過去3日間',
  Last7Days: '過去7日間',
  LastCreated: '最終作成日',
  LastDay: '最終日',
  LastModified: '最終更新日',
  LastMonth: '先月',
  LastPod: '最後のポッド',
  LastUpdated: '最終更新日',
  LastUpdatedAtTimestamp: '最終更新日時: {{timestamp}}',
  LATAM: 'ラテンアメリカ',
  LatestHourOfDataAvailable: '利用可能な最新の 1 時間のデータ:',
  LaunchTest: 'ローンチ試験',
  Length: '長さ',
  LimitedAdTracking: '広告追跡の制限機能',
  LineItem: 'ラインアイテム',
  LineItems: 'ラインアイテム',
  LineItemTargeting: 'ラインアイテムのターゲティング',
  Lines: 'ライン',
  LineUpdates: 'ラインアップデート',
  LinkCopied: 'リンクをコピーしました',
  Live: 'ライブ',
  LiveData: 'ライブデータ',
  LiveLogs: 'ライブログ',
  Liveramp: 'Liveramp',
  LiverampExtendedIDSetting: 'Liveramp 拡張ID設定',
  Livestreams: 'ライブストリーム',
  Loading: '読み込み中...',
  LoadingData: 'データを読み込んでいます...',
  LoadingEllipsis: '読み込み中...',
  LoadingItemSettings: '{{item}} の設定を読み込んでいます...',
  LocalTarget: 'ローカルターゲット',
  LocalTargeting: 'ローカルターゲティング',
  LocalTargetingAllowed: 'ローカルターゲティングが許可されています',
  LocalTargetingDescription: 'ジオターゲティングのレイヤーを組み合わせることで、場所を細かく定義できます。複数の場所を使用する場合、そのロジックはOR演算になります。つまり、定義されたいずれかの場所にいるユーザーがターゲティング対象となります。',
  LocalTargetingExcluded: 'ローカルターゲティングを除外',
  LocalTargetingIncluded: 'ローカルターゲティングを含む',
  LocalTargetingLogic: 'ローカルターゲティングロジック',
  LocalTargetingTooltipLogicAndWithText: '定義された場所がすべて一致する場合にのみ、リクエストはこの{{text}}に送信されます',
  LocalTargetingTooltipLogicOrWithText: '定義された場所のいずれかが一致する場合、リクエストはこの{{text}}に送信されます',
  LocalTargets: 'ローカルターゲット',
  LocalTargetTypes: 'ローカルターゲットタイプ',
  Logic: 'ロジック',
  LowestValueFirst: '最も低い値が最初に表示されます。',
  ManagedPlatformConnectionsPublisher: 'マネージドプラットフォーム接続パブリッシャー',
  ManagedPlatformConnectionsPublishers: 'マネージドプラットフォーム接続パブリッシャー',
  Mappings: 'マッピング',
  MarkAsAvailable: '利用可能としてマーク',
  MarkAsBooked: '予約済みとしてマーク',
  MatchDealID: 'Deal IDを一致する',
  Max: '最大',
  MaxAdDuration: '最大広告再生時間',
  MaxAdDurationOverride: '最大広告再生時間のオーバーライド',
  MaxBidFloor: '最大フロア',
  MaxKeyLengthIs: '最大キー長は',
  MaxTier: '最大ティア',
  MaxValue: '最大値',
  MaxValueLengthIs: '最大値の長さは',
  Measurement: '計測',
  Mediafile: 'メディアファイル',
  MediafileDomain: 'メディアファイルドメイン',
  Member: 'メンバー',
  MENA: '中東・北アフリカ',
  MessageTargetingFieldFromExcludingToIncluding: 'これにより、このフィールドのターゲットが「除外」から「含める」に変更されます。',
  MessageTargetingFieldFromIncludingToExcluding: 'これにより、このフィールドのターゲットが「含める」から「除外」に変更されます。',
  Metric: 'メトリック',
  Metrics: 'メトリック',
  Midroll: 'ミッドロール',
  MimeTypes: 'MIMEタイプ',
  Min: '最小',
  MinAdDuration: '最小広告再生時間',
  MinAdDurationOverride: '最小広告再生時間のオーバーライド',
  MinBidFloor: '最低フロア',
  MinimumCPMPerSecond: '1秒あたりの最小CPM',
  MinValue: '最小値',
  Miscellaneous: 'その他',
  MissingPermission: '権限がありません',
  ModalDeletedItemIDName: '{{item}}: [{{id}}] {{name}} を削除しました。',
  ModalFailedToDeleteItemIDName: '{{item}}: [{{id}}] {{name}} を削除できませんでした。',
  ModalShouldItemBeRemoved: '{{item}} を削除しますか?',
  ModalYesDeleteItem: 'はい、{{item}}を削除します。',
  Monitors: 'モニター',
  Monthly: '毎月',
  MoreInfo: '詳細情報',
  MouseOverSoundOn: 'マウスオーバーで音声オン',
  MultiBid: 'マルチ入札',
  Name: '名前',
  NameAZ: '名前A-Z',
  NetCPM: 'ネットCPM',
  Network: 'ネットワーク',
  Networks: 'ネットワーク',
  NewItemName: '新しい {{item}} の名前',
  NoCityAvailable: '選択できる都市がありません',
  NoDataFound: 'データが見つかりません。',
  NoDataToDisplay: '表示するデータがありません',
  NoItemFound: '{{item}}が見つかりません',
  NoItemSelected: '{{item}}が選択されていません',
  NoMax: '最大なし',
  None: 'なし',
  NonOptOut: 'オプトアウトなし',
  NoResultsFound: '結果が見つかりませんでした。',
  NorthAmerica: '北米',
  NotApplicable: '該当なし',
  NoticeSelectAtLeastOneChannelOrChannelGroup: '少なくとも 1 つのチャネルまたはチャネル グループを選択します。',
  NotIncludedInForecast: '予測には含まれません',
  NotLowPacing: '低ペースではない',
  NotRunning: '実行されていません',
  NotScheduled: '予定なし',
  NotStartedYet: '未配信',
  NumDeliveredToDate: '現在までに{{count}}件が配信されました。',
  NumItemsSelected: '{{count}} {{item}} 個選択済み',
  NumRows: '{{count}}列',
  NumSelected: '{{count}} 個選択済み',
  OneHourFromNow: '1時間後',
  OneItemSelected: '1 {{item}} が選択されました',
  OpenItem: '{{item}} を開く',
  OptimizationInsights: '最適化の詳細',
  OptimizedFloor: '最適化されたフロア',
  OptIn: 'オプトイン',
  Option: 'オプション',
  Options: 'オプション',
  OptOut: 'オプトアウト',
  Or: 'Or',
  Order: 'オーダー',
  OrderBy: '並べ替え',
  Orders: 'オーダー',
  OriginalBidResponse: 'オリジナルビッドレスポンス',
  OriginalDIDs: '元のデバイスID',
  OriginalVAST: 'オリジナルVAST',
  ORTBObjects: 'ORTBオブジェクト',
  ORTBType: 'oRTBタイプ',
  OutboundDeals: 'アウトバウンドディール',
  OutOfRangeDays: '範囲外の日数',
  Overview: 'オーバービュー',
  Pacing: 'ペーシング',
  PageLoadSoundOff: 'ページ読み込み時に音声オフ',
  PageLoadSoundOn: 'ページ読み込み時に音声オン',
  Parameter: 'パラメータ',
  Parameters: 'パラメータ',
  Partner: 'パートナー',
  PassID: 'パスID',
  PercentL12HFloor: '% L12H フロア',
  PercentL12HUplift: 'L12H 上昇率',
  Performances: 'パフォーマンス',
  Period: '期間',
  PeriodRange: '期間範囲',
  Permission: '許可',
  PermissionWithAsterisk: '許可 *',
  PG: 'PG',
  PlaceholderEnterContentItemToBeBidOnHereCommaSeparated: '入札するコンテンツ {{item}} をコンマで区切ってここに入力してください。',
  PlaceholderEnterContentItemToBidOn: '入札するコンテンツ {{item}} を入力します。コンマで区切ることができます。',
  PlaceholderEnterCustomItemHereCommaSeparated: 'ここにカスタム {{item}} を入力してください。カンマ区切りで入力できます。',
  PlaceholderEnterCustomItemName: 'カスタム {{item}} 名を入力します。',
  PlaceholderEnterItem: '{{item}} を入力してください。',
  PlaceholderEnterItemCommaSeparatedHere: 'ここに{{item}}をコンマで区切って入力してください。',
  Placement: 'プレイスメント',
  PlatformConnect: 'プラットフォームコネクト',
  PlaybackMethod: 'プレイバック メソッド',
  PlaybackMethods: 'プレイブックメソッド',
  PlusAdd: '+ を追加',
  PlusAddItem: '+ {{item}} を追加',
  PlusItem: '+ {{item}}',
  PMP: 'PMP',
  PoddedRequest: 'ポッドリクエスト',
  PoddedRequestType: 'ポッドリクエストタイプ',
  PodDurations: 'ポッドデュレーション',
  PodSequence: 'Pod Sequence',
  Portuguese: 'ポルトガル語',
  Position: 'Position',
  PostBidAdvertiserReportingDoubleVerify: 'Post Bid Advertiser Reporting (DoubleVerify)',
  PostBidAdvertiserReportingIAS: 'Post Bid Advertiser Reporting (IAS)',
  Postroll: 'ポストロール',
  Prefix: 'プレフィックス',
  Preroll: 'プリロール',
  Preset: 'プリセット',
  PresetAssociations: 'プリセットの関連付け',
  Presets: 'プリセット',
  Preview: 'プレビュー',
  PreviousPeriod: '前期',
  PreviousTest: '前回のテスト',
  PreviousTests: '以前のテスト',
  Price: '価格',
  PriceRange: '価格帯',
  Prices: '価格',
  Privacy: 'プライバシー',
  PrivateAuction: 'プライベートオークション',
  Prodqual: 'Prodqual',
  Producer: 'プロデューサー',
  ProducerID: 'プロデューサーID',
  ProducerName: 'プロデューサー名',
  Profile: 'プロフィール',
  PublicaDealID: 'Publica ディールID',
  Publisher: 'パブリッシャー',
  PublisherID: 'パブリッシャーID',
  PublisherName: 'パブリッシャー名',
  PublisherNames: 'パブリッシャー名',
  PublisherSeat: 'パブリッシャーシート',
  Range: '範囲',
  Rating: '評価',
  ReadOnly: '読み取り専用',
  Ready: '準備完了',
  Recipient: '受信者',
  Recipients: '受信者',
  Refresh: 'リフレッシュ',
  RefreshChanges: '変更を更新',
  Region: '地域',
  RegionName: '地域名',
  Regions: '地域',
  Remove: '取り除く',
  RemoveContentItem: 'コンテンツ{{item}}を削除',
  RemoveContentItemFromRequest: 'リクエストからコンテンツ {{item}} を削除します。',
  RemoveEntireContentObjectFromBidRequest: 'ビッドリクエストから content オブジェクト全体を削除する',
  RemoveFMTJSON: 'Fmt JSON を削除する',
  RemoveGPPFromBidRequest: 'ビッドリクエストから GPP',
  RemoveItem: '{{item}}を削除します。',
  RemoveItemFromRequest: 'リクエストから {{item}} を削除します。',
  RepeatingOn: '繰り返しオン',
  Report: 'レポート',
  Reporting: 'レポート',
  Reports: 'レポート',
  ReportType: 'レポートの種類',
  ReportTypes: 'レポートの種類',
  RequestedPodDurationSeconds: 'リクエストされたポッドデューレーション（秒）',
  RequiredDuration: 'リクエストされたデュレーション',
  Reset: 'リセット',
  ResponsesBlocked : 'ブロックされたレスポンス数',
  Restrict: '制限',
  RestrictedToSuperAdmin: 'スーパー管理者に制限',
  Revenue: '収益',
  Revert: '元に戻す',
  ReviewEditedFields: '編集したフィールドを確認する',
  RevL24H: '収益 (L24H)',
  RevL7D: '収益（L7D）',
  RevTrend: '収益トレンド',
  Rewrites: '上書き',
  Routes: 'ルート',
  Rows: '行',
  RuleName: 'ルール名',
  RunForecast: '予測を実行する',
  Running: 'ランニング',
  SamplingDaysDisabled: 'サンプリング日無効',
  SamplingDisabledUntil: 'サンプリングが無効になるまで',
  SamplingPercentage: 'サンプリング率',
  Save: '保存',
  SaveAndEmail: '保存してメール送信',
  SaveItem: '{{item}} を保存',
  SaveWithoutLaunching: 'ローンチせずに保存',
  Schedule: 'スケジュール',
  Scheduled: '予定',
  ScheduledDay: '予定日',
  Search: '検索',
  SearchByDemandSource: 'デマンドソースを検索',
  SearchByKeywordOrValue: 'キーワードまたは値で検索します。',
  SearchByName: '名前で検索',
  SearchByNameID: '名前、IDで検索',
  Season: 'シーズン',
  Seat: 'シート',
  SecondaryRequests: 'セカンダリリクエスト',
  SectionIDs: 'セクションID',
  SeeItem: '{{item}} を参照',
  SegmentAndOr: 'セグメントおよび/または',
  Segments: 'セグメント',
  Select: '選択',
  SelectAll: 'すべて選択',
  SelectAndAddIABCat: 'IAB カテゴリを選択して追加します。',
  SelectCountriesToIncludeInRegion: '地域に含める国を選択',
  SelectDemandSource: 'デマンドソースを選択',
  Selected: '選択済み',
  SelectedLineItems: '選択したラインアイテム',
  SelectedOrders: '選択されたオーダー',
  SelectErrorMustSelectOption: '続行するにはオプションを選択する必要があります。',
  SelectItem: '{{item}}を選択',
  SelectUpToNumItems: '最大 {{number}} 個の {{item}} を選択してください。',
  Series: 'シリーズ',
  SetItem: '{{item}} を設定する',
  SetLimitTo: 'リミットを設定',
  Settings: '設定',
  ShareAsLink: 'リンクとして共有',
  SharedWithBackfill: 'バックフィルと共有',
  SharedWithNoBackfill: 'バックフィルなしで共有',
  ShareOfVoice: 'シェア・オブ・ボイス',
  ShareOfVoiceType: 'シェア・オブ・ボイスタイプ',
  ShowAll: 'すべて表示',
  ShowInactive: '非アクティブを表示',
  Showing: '表示中',
  ShowingActiveOnly: 'アクティブのみ表示',
  ShowingAll: 'すべて表示',
  ShowingInactiveOnly: '非アクティブのみ表示',
  ShowingNumOfTotalResults: '{{number}} 件中 {{total}} 件の結果を表示しています。',
  ShowItem: '{{item}} を表示',
  Site: 'サイト',
  SiteDomain: 'サイトドメイン',
  SiteDomainOverride: 'サイトドメインのオーバーライド',
  SiteDomainOverrideIfEmpty: 'サイトドメインが空の場合にオーバーライド',
  SiteDomainOverrideWithAsterisk: 'サイトドメインのオーバーライド *',
  SiteDomains: 'サイトのドメイン',
  SitePage: 'サイトページ',
  SitePages: 'サイトページ',
  Sites: 'サイト',
  SiteSection: 'サイトセクション',
  SiteWeightEnabled: 'サイトのウエイトが有効',
  SiteWithAsterisk: 'サイト *',
  Skip: 'スキップ',
  SkipAfter: 'スキップ後',
  SkipMin: 'スキップ分',
  Slot: 'Slot',
  SlotCount: 'スロット数',
  Slots: 'Slots',
  Smart: 'スマート',
  SmartFloors: 'スマートフロア',
  Smooth: 'スムーズ',
  SnackbarChangesSavedWithWarnings: '変更は保存されましたが、いくつかの警告があります。',
  SnackbarConnectionErrorPleaseTryAgain: '接続エラーが発生しました。もう一度お試しください',
  SnackbarErrorDeletingItem: '{{item}} の削除中にエラーが発生しました。更新してください。',
  SnackbarErrorRefreshingDataLastUpdatedAtTimestamp: 'データの更新中にエラーが発生しました。データは{{timestamp}}に最後に正常に更新されました。',
  SnackbarErrorRetrievingData: 'データの取得中にエラーが発生しました。しばらくしてからもう一度お試しください。',
  SnackbarErrorRetrievingFilters: 'フィルターの取得中にエラーが発生しました。しばらくしてからもう一度お試しください。',
  SnackbarErrorRetrievingItem: '{{item}} の取得中にエラーが発生しました。しばらくしてからもう一度お試しください。',
  SnackbarFailedToCloneItem: '{{item}} のクローン作成に失敗しました。',
  SnackbarFailedToCreateItem: '{{item}} の作成に失敗しました。',
  SnackbarFailedToDeleteItem: '{{item}} を削除できませんでした。',
  SnackbarFailedToLoadBidderConfiguration: 'ビダー設定の読み込みに失敗しました。',
  SnackbarFailedToParseDebugInfo: 'デバッグ情報の解析に失敗しました。',
  SnackbarFailedToUpdateIDName: '[{{id}}] {{name}} の更新に失敗しました。',
  SnackbarFailedToUpdateItem: '{{item}} の更新に失敗しました。',
  SnackbarInvalidConfigurationDetected: '無効な設定が検出されました。',
  SnackbarItemAlreadyExistWithReasons: '{{item}} はすでに存在します: {{text}}',
  SnackbarItemCreatedSuccessfully: '{{item}} が正常に作成されました。',
  SnackbarItemIDDeletedSuccessfully: '{{item}} {{id}} が正常に削除されました。',
  SnackbarItemIDDeletionFailed: '{{item}} {{id}} の削除に失敗しました。',
  SnackbarItemSavedSuccessfully: '{{item}} が正常に保存されました。',
  SnackbarItemSettingsSaved: '{{item}} の設定が保存されました。',
  SnackbarItemUpdatedSuccessfully: '{{item}} が正常に更新されました。',
  SnackbarNoDataFound: 'データが見つかりません。',
  SnackBarNoLiveDataFound: 'ライブデータが見つかりません。',
  SnackbarPleaseFixErrorsBeforeSavingItemWithReasons: '{{item}} を保存する前にエラーを修正してください: {{text}}',
  SnackbarSelectedItemDoesNotExist: '選択された{{item}}は存在しません。',
  SnackbarSuccessfullyCreatedItem: '{{item}} を正常に作成しました。',
  SnackbarSuccessfullyDeletedItem: '{{item}} を正常に削除しました。',
  SnackbarSuccessfullyDeletedNumItems: '{{count}} {{item}} を正常に削除しました。',
  SnackbarSuccessfullySavedItem: '{{item}} を正常に保存しました。',
  SnackbarSuccessfullyUpdatedIDName: '[{{id}}] {{name}} を正常に更新しました。',
  SnackbarSuccessfullyUpdatedItem: '{{item}} を正常に更新しました。',
  SnackbarUnableToLoadItemData: '{{item}} データを読み込めません。',
  SnackbarUnableToSaveChangesAtThisTime: '現時点では変更を保存できません。',
  SnackbarValidationFailedPleaseCheckYourInputs: '検証に失敗しました。入力内容を確認してください。',
  SortBy: '並べ替え',
  SOVBackfill: 'SOVバックフィル',
  SOVParallelAuctions: 'SOVパラレルオークション',
  Spanish: 'スペイン語',
  SplitShareByDuration: '尺（秒数）別にシェアを配分',
  SplitShareByPod: 'ポッド単位でのシェア分配',
  SponsorshipMode: 'スポンサーシップモード',
  Start: '開始',
  StartDate: '開始日',
  StartDateRange: '開始日の範囲',
  StartDelayOverride: '開始遅延オーバーライド',
  StartTime: '開始時間',
  State: '州',
  States: '州',
  Status: 'ステータス',
  StoreURL: 'ストアURL',
  Stream: 'ストリーム',
  StreamTypes: 'ストリームの種類',
  Structured: 'ストラクチャー',
  StructuredSlot: '構造的スロット',
  SubjectName: '件名',
  Subtypes: 'サブタイプ',
  Summary: 'まとめ',
  SuperUserOnly: 'スーパーユーザーのみ',
  Supply: 'サプライ',
  SyntheticDIDs: '合成デバイスID',
  Tag: 'タグ',
  TargetedAdBreaks: 'ターゲット広告ブレーク',
  TargetedChannelGroups: 'チャネルグループ',
  TargetedChannelLists: 'ターゲットチャンネルリスト',
  TargetedChannels: 'チャネル',
  TargetedCountries: '対象国',
  TargetedCountriesAllowed: '対象国が許可される',
  TargetedDeals: 'ターゲットされたディール',
  TargetedDevices: '対象デバイス',
  TargetedDevicesAllowed: '許可された対象デバイス',
  TargetedDeviceSubtypes: '対象デバイスのサブタイプ',
  TargetedDeviceSubtypesAllowed: '許可されるターゲットデバイスのサブタイプ',
  TargetedDeviceTypes: '対象デバイスの種類',
  TargetedDeviceTypesAllowed: '許可される対象デバイスの種類',
  TargetedLineItems: 'ターゲットラインアイテム',
  TargetedLivestream: 'ターゲティングされたライブ配信',
  TargetedLivestreams: 'ターゲットを絞ったライブストリーム',
  TargetedOrders: 'ターゲティングされた広告注文',
  TargetedRegions: '対象地域',
  TargetedRegionsAllowed: '対象地域が許可されています',
  TargetedSegments: 'ターゲットセグメント',
  TargetedSegmentsAllowed: 'ターゲットセグメントの許可',
  TargetedSiteDomainAllowed: '対象サイトのドメインが許可されています',
  TargetedSitePagesAllowed: '許可されたターゲットサイトのページ',
  TargetFirstAdbreakInSessionWithAsterisk: 'セッション中の最初の広告ブレークをターゲットにする *',
  Targeting: 'ターゲティング',
  TargetingChange: 'ターゲットを変更する',
  TargetingDeviceIDType: 'ターゲットデバイスIDタイプ',
  TargetingParameters: 'ターゲティングパラメータ',
  TargetingPresets: 'ターゲティング プリセット',
  TargetingStateTooltip: '都市ターゲティングの精度を確保するため、可能な場合は単一の州を選択してください',
  TestIncrement: 'テスト増分',
  TestingRange: 'テスト範囲',
  Tests: 'テスト',
  Threshold: 'しきい値',
  Tier: 'ティア',
  TierNumber: 'ティア {{number}}',
  Time: '時間',
  TimePeriod: '期間',
  TimePeriods: '期間',
  Timestamp: 'タイムスタンプ',
  Timezone: 'タイムゾーン',
  Timezones: 'タイムゾーン',
  Title: 'タイトル',
  TmaxOffset: 'Tmaxオフセット',
  To: 'To',
  Tools: 'ツール',
  TooltipAvgCPML24H: '過去24時間の平均CPM',
  TooltipAvgCPML7D: '過去7日間の平均CPM',
  TooltipBeta:'この機能はベータ版です。この機能のテストにご興味がある場合は、アカウントマネージャーにお問い合わせください。',
  TooltipContentItemToBidOn: '入札するコンテンツ {{item}} はコンマで区切ることができます。',
  TooltipCustomName: 'ホームページに表示するカスタム名。',
  TooltipCustomParamReseller: '{{item}}エンドポイントへのリクエストに設定されたカスタムパラメータを確認し、ビダーを含めるか除外するかを決定します。カンマ区切りで指定できます。',
  TooltipEndpointReqL24H: 'エンドポイントリクエストの過去24時間',
  TooltipEndpointReqL7D: '過去7日間のエンドポイントリクエスト',
  TooltipExcludedToggleToInclude: '除外 - 含めるに切り替える',
  TooltipForecastIsTemporarilyUnavailable: '予測は現在ご利用いただけません。しばらくしてから再度ご確認ください。',
  TooltipImpL24H: 'インプレッションは24時間持続します',
  TooltipImpL7D: '直近7日間のインプレッション数',
  TooltipImpressionsTrend: '直近7日間のインプレッション数の推移（前週比）',
  TooltipIncludedToggleToExclude: '含まれる - 除外に切り替える',
  TooltipOpenItem: '{{item}} を開きます。',
  TooltipRevenueTrend: '前期と比較したL7Dの収益動向',
  TooltipRevL24H: '過去24時間の収益',
  TooltipRevL7D: '直近7日日間の収益',
  TooltipUnavailableDueToSelectedFilters: '選択されたフィルターの条件により表示できません。',
  TooltipUnavailableDueToSelectedPeriod: '選択された期間では利用できません。',
  TopAvgCPML24H: '上位平均CPM',
  TopAvgCPML7D: '上位平均CPM（L7D）',
  TopChannels: 'トップチャンネル',
  TopDemandSources: 'トップデマンドソース',
  TopEndpointReqsL24H: 'トップエンドポイントリクエスト',
  TopEndpointReqsL7D: 'トップエンドポイントリクエスト (L7D)',
  TopEndpointRequests: '上位のエンドポイントリクエスト',
  TopImpressions: 'トップインプレッション',
  TopImpressionsL24H: 'トップインプレッション',
  TopImpressionsL7D: 'トップインプレッション（L7D）',
  TopItemByAltItem: '{{altItem}} によるトップ {{item}}',
  TopNum: 'トップ {{number}}',
  TopRevenue: 'トップ収益',
  TopRevenueL24H: '上位収益',
  TopRevenueL7D: '上位収益（L7D）',
  Tracking: 'トラッキング',
  Trends: 'トレンド',
  True: 'True',
  Type: 'タイプ',
  UIBrandsDashboard: 'ブランド ダッシュボード',
  UICreativeLibrary: 'クリエイティブ ライブラリ',
  UID20: 'UID 2.0',
  UID20ExtendedIDSetting: 'UID 2.0 拡張ID設定',
  UIPlatformConnect: 'プラットフォーム コネクト',
  UnableToSendEmail: 'メールを送信できません',
  Unit: 'ユニット',
  Unknown: '不明',
  UnknownItem: '不明 {{item}}',
  UnpaidBidder: '未払いビダー',
  Unscheduled: '予定無し',
  Untargeted: '非対象',
  UnwrappedVAST: 'アンラップされたVAST',
  Upcoming: '今後の予定',
  UpdateItem: '{{item}} を更新',
  Updates: 'アップデート',
  UploadCSV: 'CSVをアップロード',
  UploadCSVToSharedS3RoleTooltip: 'テーブルにデータを入力するには、共有S3ロール経由でCSVをアップロードしてください。',
  UploadItem: '{{item}}をアップロード',
  UploadNewItem: '新しい {{item}} をアップロード',
  User: 'ユーザー',
  UserHaveNoPermission: '申し訳ありませんが、このセクションへの権限がありません',
  Users: 'ユーザー',
  UseVASTPriceExtension: 'VAST価格拡張機能を使用する',
  UUID: 'UUID',
  Value: 'バリュー',
  Values: '値',
  VASTPriceExtension: 'VASTプライスエクステンション',
  VASTURL: 'VAST URL',
  VASTURLInfo: 'サポートされているマクロについては、Wiki を参照してください。',
  Venue: '会場',
  VenueID: '会場ID',
  Video: 'ビデオ',
  ViewBy: 'ビュー',
  ViewCurrentItem: '現在の {{item}} を表示',
  Viewer: '視聴者',
  Webhook: 'ウェブフック',
  Weekly: '毎週',
  YahooConnectID: 'Yahoo Connect ID',
  YAxisMetric: 'Y軸メトリック',
  YesConfirmUpdates: 'はい、更新を確認します。',
  ZIP: '郵便番号',
  ZIPCode: '郵便番号',
  ZIPs: '郵便番号',
  Zone: 'ゾーン',
};
